module.exports = __webpack_public_path__ + "img/autoconta chido.0c167615.jpg";